import React from 'react';
import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api';

// Same libraries as LocationPicker so the loader is shared / reused
const LIBRARIES = ['places'];

/**
 * Read-only map showing a pin at the given lat/lng.
 * Props: lat, lng, height (px, default 220)
 */
const LocationMap = ({ lat, lng, height = 220 }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey || '',
    libraries: LIBRARIES,
  });

  if (!apiKey || !isLoaded) {
    return <div style={{ height }} className="bg-gray-100 animate-pulse rounded-lg" />;
  }

  const center = { lat, lng };

  return (
    <div style={{ height }} className="rounded-lg overflow-hidden">
      <GoogleMap
        center={center}
        zoom={15}
        mapContainerStyle={{ width: '100%', height: '100%' }}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: true,
          gestureHandling: 'cooperative',
        }}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
};

export default LocationMap;
